import { gql } from "@apollo/client";

export const GET_ALL_MODALIDAD_PROFESIONAL_COBRO = gql`
query GetAllModalidadProfesionalCobro {
    allModalidadProfesionalCobro {
            idModalidadProfesionalCobro,
            nombre,
            abreviacion,
            activo,
            
      }
}`;